<template lang="pug">
  div.cartvue
    div.row.justify-content-center
      div.col-12.col-md-11.col-lg-10.col-xl-9
        h4(style="text-align: left;")
          font-awesome-icon(icon="shopping-cart", style="margin: 0px 10px;")
          | Cart
        div(v-show="!fail && result.status==200 && result.amount==0", style="paddint-left:20px;")
          span カートは空です
        div(v-show="fail", style="paddint-left:20px;", @click="reload")
          span(style="cursor:pointer")
            | 読み込みに失敗しました
            br
            | クリックして再読み込みする
        div(v-show="!fail && result.status==200", v-for=" (item, index) in result.results", :key="item.item_id")
          div.row.align-items-center
            div.col-6.col-md-7(style="padding: 5px 5px 5px 10px;")
              a.btn.btn-link.area-label.collapsed(
                  data-toggle="collapse",
                  aria-expanded="false",
                  :aria-controls="'detail'+item.item_id",
                  role="button",
                  :href="'#detail'+item.item_id",
                  style="padding: .5rem 0rem;",
                  :id="'itemheader'+item.item_id"
              ) {{ item.y }} {{ item.s }}
            div.col-4.col-md-3(style="padding:0px;")
              div.row
                div.col-12.col-lg-6.align-self-center(style="padding:0px;")
                  span(style="margin-bottom:0px;") {{ item.is_set? "セット":"単品" }} {{ item.qno }}
                div.col-12.col-lg-6.align-self-center(style="padding:0px;")
                  span(style="margin-bottom:0px;") ￥{{ item.price.toLocaleString() }}
            div.col-2.align-self-center
              button.btn.btn-secondary(type="button", @click="removeCart(item.item_id, index)") 削除
            
            
          div.collapse(:id="'detail'+item.item_id")
            div.row(style="margin-top:5px;")
              div.col-12
                div
                  table.table.table-sm(style="text-align:center; font-size:12px; margin-bottom: 0px;")
                    thead
                      tr
                        th 勤続年数
                        th 受験年齢
                        th 私費・社費
                        th キャリア
                        th 希望進路
                        th 志望キャリア
                    tbody
                      tr
                        td(style="vertical-align:middle;") {{ item.l }}
                        td(style="vertical-align:middle;") {{ item.a }}
                        td(style="vertical-align:middle;") {{ item.e? "私費":"社費" }}
                        td(style="vertical-align:middle;") {{ $store.state.careerl[item.c1] }}<br>{{ $store.state.careers[item.c1] }}
                        td(style="vertical-align:middle;") {{ $store.state.postmba[item.p] }}
                        td(style="vertical-align:middle;") {{ $store.state.careerl[item.c2] }}<br>{{ $store.state.careers[item.c2] }}
              div.col-12(style="text-align: left; font-size: 13px;")
                p(v-for="q in item.q" :key="q") {{ q }}
            hr(style="margin:5px;")
        div.loader(v-show="!fail && result.status==0")
          div.loader-inner.ball-clip-rotate
            div
        div.row.justify-content-center
          div.col-9(style="text-align:right; margin-top: 25px;")
            span(v-show="result.status==200", style="font-size: 25px;margin: 10px; text-decoration: underline;") 合計金額 ￥{{ result.amount.toLocaleString() }}
</template>


<script>

export default {
  name: 'CartVue',
  components: {
  },
  data (){
      return {
          result:{ status:0, amount:0 },
          fail:false,
      }
  },
  mounted (){
      this.reload();
  },
  methods:{
      removeCart: function(item_id, index){
          this.$store.commit("removeCart", item_id);
        this.result.amount -= this.result.results[index].price;
        this.$store.commit("amount", this.result.amount);
        this.result.results.splice(index,1);
    },
    reload (){
      this.fail = false;
      let data = this.$store.state.listitems.cart;
      this.$axios.post("/api/cartdetail", data)
      .then((response) => {
        this.result = response.data;
        this.$store.commit("amount", this.result.amount);
      })
      .catch((error) => {
          this.fail = true;
      });

    },
  }
}
</script>



<style scoped>

.ball-clip-rotate>div {
    border: 3px solid lightgray!important;
    border-bottom-color: transparent!important;
    width: 50px!important;
    height: 50px!important;
}


a.btn.btn-link.btn-lg.area-label {
  display: flex;
}

a[aria-expanded="false"]:before {
  content: url("data:image/svg+xml;base64,PHN2ZyBkYXRhLWljb249ImNoZXZyb24tZG93biIgcm9sZT0iaW1nIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NDggNTEyIj48cGF0aCBmaWxsPSIjMDA3YmZmIiBkPSJNMjA3LjAyOSAzODEuNDc2TDEyLjY4NiAxODcuMTMyYy05LjM3My05LjM3My05LjM3My0yNC41NjkgMC0zMy45NDFsMjIuNjY3LTIyLjY2N2M5LjM1Ny05LjM1NyAyNC41MjItOS4zNzUgMzMuOTAxLS4wNEwyMjQgMjg0LjUwNWwxNTQuNzQ1LTE1NC4wMjFjOS4zNzktOS4zMzUgMjQuNTQ0LTkuMzE3IDMzLjkwMS4wNGwyMi42NjcgMjIuNjY3YzkuMzczIDkuMzczIDkuMzczIDI0LjU2OSAwIDMzLjk0MUwyNDAuOTcxIDM4MS40NzZjLTkuMzczIDkuMzcyLTI0LjU2OSA5LjM3Mi0zMy45NDIgMHoiPjwvcGF0aD48L3N2Zz4K");
  margin-right: 7px;
  overflow: visible;
  width: 0.875em;
  display: inline-block;
  font-size: inherit;
  height: 1em;
  vertical-align: -0.125em;
}

a[aria-expanded="true"]:before {
  content: url("data:image/svg+xml;base64,PHN2ZyBkYXRhLWljb249ImNoZXZyb24tdXAiIHJvbGU9ImltZyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgNDQ4IDUxMiI+PHBhdGggZmlsbD0iIzAwN2JmZiIgZD0iTTI0MC45NzEgMTMwLjUyNGwxOTQuMzQzIDE5NC4zNDNjOS4zNzMgOS4zNzMgOS4zNzMgMjQuNTY5IDAgMzMuOTQxbC0yMi42NjcgMjIuNjY3Yy05LjM1NyA5LjM1Ny0yNC41MjIgOS4zNzUtMzMuOTAxLjA0TDIyNCAyMjcuNDk1IDY5LjI1NSAzODEuNTE2Yy05LjM3OSA5LjMzNS0yNC41NDQgOS4zMTctMzMuOTAxLS4wNGwtMjIuNjY3LTIyLjY2N2MtOS4zNzMtOS4zNzMtOS4zNzMtMjQuNTY5IDAtMzMuOTQxTDIwNy4wMyAxMzAuNTI1YzkuMzcyLTkuMzczIDI0LjU2OC05LjM3MyAzMy45NDEtLjAwMXoiPjwvcGF0aD48L3N2Zz4=");
  margin-right: 7px;
  overflow: visible;
  width: 0.875em;
  display: inline-block;
  font-size: inherit;
  height: 1em;
  vertical-align: -0.125em;
}

.cartvue {
    margin-top:15px;
}
</style>